import { CacheableDataObject } from 'models/CacheableDataObject';

export default class PlayOption extends CacheableDataObject {

	get is_ranked() {
		return this.isRanked;
	}

	get team_size() {
		return this.teamSize;
	}

	get ladder_id() {
		return this.ladderId;
	}

	get match_count() {
		return this.gameCount;
	}

	toString() {
		return `${this.ladder_id}-${this.gameCount}-${this.isRanked}-${this.teamSize}-${this.ladderId}`;
	}

	getTitle() {
		let title = '';
		if(this.gameCount === 0) {
			title = 'Endless';
		}
		else {
			title = `Best Of ${this.gameCount}`;
		}
		return title;
	}

	serializeAsMatch() {
		return {
			ranked: this.is_ranked,
			team_size: this.teamSize,
			ladder_id: this.ladderId,
			match_count: this.gameCount,
		};
	}
}
